<template>
  <button :class="{'is_selected': selected}" class="image_button" v-on:click="clickButton" >
    <div :class="buttonView.class" class="img_part"></div>
    <div class="text">{{buttonView.text}}</div>
  </button>
</template>

<script>

export default {
  props: {
      selected: {
          type: Boolean,
          default: false
      },
      field: {
          type: String,
          default: ''
      },
      value: {
          type: String,
          default: ''
      }
  }, 
  data() {
    return {};
  },
  computed: {
      buttonView: function buttonText(){
          var ident = this.field + '-' + this.value;
          var return_object = { class: 'button_', text: ''};
          switch (ident) {
              case 'purpose-buy': return_object.class += 'icon1'; return_object.text = 'Buy a farm'; break;
              case 'purpose-refinance': return_object.class += 'icon2'; return_object.text = 'Refinance'; break;
              case 'purpose-both': return_object.class += 'icon3'; return_object.text = 'Both'; break;

              case 'owner_type-trust': 
              case 'operator_type-trust': return_object.class += 'icon4'; return_object.text = 'Trust'; break;
              case 'owner_type-individual': 
              case 'operator_type-individual': return_object.class += 'icon5'; return_object.text = 'Individual'; break;
              case 'owner_type-partnership': 
              case 'operator_type-partnership': return_object.class += 'icon6'; return_object.text = 'Partnership'; break;
              case 'owner_type-company' : 
              case 'operator_type-company': return_object.class += 'icon7'; return_object.text = 'Company'; break;
              
              case 'farm_type-beef': return_object.class += 'icon8'; return_object.text = 'Beef'; break;
              case 'farm_type-sheep': return_object.class += 'icon9'; return_object.text = 'Sheep'; break;
              case 'farm_type-both': return_object.class += 'icon10'; return_object.text = 'Both'; break;
              case 'farm_type-other': return_object.class += 'icon11'; return_object.text = 'Other'; break;

              //#pjw
              case 'farm_type-dairy': return_object.class += 'icon12'; return_object.text = 'Dairy'; break;

              default: break;
          }
          return return_object
      }
  },
  methods: {
      clickButton: function clickButton(){
          var obj = {
              property: this.field,
              value: this.value
          }
          this.$emit('sendDataToApp', obj)
      }
  }
};
</script>